import { GridWrapper } from "@insite/mobius/GridContainer";
import { GridItemStyle } from "@insite/mobius/GridItem";
import { clearfixStyles, contentSpacingStyles } from "@tKgpco/theme/mixins";
import { css } from "styled-components";

export default {
    css: css`
        * {
            outline: 5px solid red;
        }
        /* stylelint-disable property-no-vendor-prefix */
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }
        input[type="number"] {
            -moz-appearance: textfield;
        }
        /* stylelint-enable property-no-vendor-prefix */
        main {
            ${GridWrapper} {
                ${clearfixStyles()}
                max-width: none;
            }

            ${GridItemStyle} {
                overflow-wrap: normal;
                word-wrap: normal;
                -ms-word-break: normal;
                word-break: normal;
            }
        }
    `,
};
